"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sparkline = exports.radio = exports.none = exports.input = exports.focusRing = exports.checkbox = exports.card = exports.button = exports.borderWidthVariables = void 0;
require("./borderWidth.css");
var _borderWidth2 = require("@cbhq/cds-common/tokens/borderWidth");
var _tokens = require("../tokens");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

// eslint-disable-next-line no-restricted-imports

const borderWidthVariables = {
  '--border-width-none': `${_borderWidth2.borderWidth.none}px`,
  '--border-width-button': `${_borderWidth2.borderWidth.button}px`,
  '--border-width-card': `${_borderWidth2.borderWidth.card}px`,
  '--border-width-checkbox': `${_borderWidth2.borderWidth.checkbox}px`,
  '--border-width-radio': `${_borderWidth2.borderWidth.radio}px`,
  '--border-width-sparkline': `${_borderWidth2.borderWidth.sparkline}px`,
  '--border-width-focus-ring': `${_borderWidth2.borderWidth.focusRing}px`,
  '--border-width-input': `${_borderWidth2.borderWidth.input}px`
};
exports.borderWidthVariables = borderWidthVariables;
const none = "cds-none-n1kahbb4";
exports.none = none;
const button = "cds-button-b18qe5go";
exports.button = button;
const card = "cds-card-c1uxfzzy";
exports.card = card;
const checkbox = "cds-checkbox-c60tdhe";
exports.checkbox = checkbox;
const radio = "cds-radio-rfry6c4";
exports.radio = radio;
const sparkline = "cds-sparkline-s15jdd1s";
exports.sparkline = sparkline;
const focusRing = "cds-focusRing-fzql8bu";
exports.focusRing = focusRing;
const input = "cds-input-i1ykumba";
exports.input = input;